import { Component, EventEmitter, Input, Output } from '@angular/core';

import { TranslationKeyMap } from '../gp-main.i18n';
import { gpCompareRows } from '../gp-sort.util';
import { ViewPersonaGroup } from '../model/view-persona-group.model';
import { ViewRow } from '../view-row.model';

@Component({
    selector: 'cmps-gp-persona-tile',
    templateUrl: './gp-persona-tile.component.html',
})
export class GpPersonaTileComponent {
    /** @private */
    _i18n = TranslationKeyMap;

    @Input() group: ViewPersonaGroup;

    /** @private */
    _sortColumn = 'nba';

    /** @private */
    _sortOrder = 'desc';

    @Output() wpClick = new EventEmitter<ViewRow>();

    get _sortedRows(): ViewRow[] {
        if (this.group.rows.length === 0) return [];
        return [...this.group.rows].sort((a, b) =>
            gpCompareRows(a, b, this._sortColumn, this._sortOrder),
        );
    }

    _trackByRow(_: number, row: ViewRow): number {
        return row.row.userId;
    }

    _onSortClick(column: string): void {
        const order =
            column !== this._sortColumn
                ? 'asc'
                : this._sortOrder === 'asc'
                ? 'desc'
                : 'asc';
        this._sortColumn = column;
        this._sortOrder = order;
    }
}
